import { createAction, handleActions, Reducer } from 'redux-actions';
import { HistoryEvent } from '@api/types';
import { SelectorState } from '@redux/types';

type HistoryEventsReducer<T = HistoryEventsState> = Reducer<HistoryEventsState, T>;

export interface HistoryEventsState {
  events: HistoryEvent[];
  isLoading: boolean;
  offset: number;
  limit: number;
  term: string;
}

const DEFAULT_LIMIT = 25;

export const initialState: HistoryEventsState = {
  events: [],
  isLoading: false,
  limit: DEFAULT_LIMIT,
  offset: 0,
  term: '',
};

const INITIALIZE = 'historyEvents/INITIALIZE';
const LOAD_MORE = 'historyEvents/LOAD_MORE';

const FETCH_SUCCESS = 'historyEvents/FETCH_SUCCESS';
const FETCH_FAILED = 'historyEvents/FETCH_FAILED';

// TODO remove when AccountHistoryController is migrated
export type TempAngularJSSupporting = {
  onSuccessToAngularJs?: (events: HistoryEvent[]) => void;
  onErrorToAngularJs?: () => void;
};

export type InitializePayload = { limit: number; term?: string } & TempAngularJSSupporting;
export type LoadMorePayload = { term: string } & TempAngularJSSupporting;
export type FetchSuccessPayload = { events: HistoryEvent[]; offset: number };

export const initialize = createAction<InitializePayload>(INITIALIZE);
export const loadMore = createAction<LoadMorePayload>(LOAD_MORE);

export const fetchSuccess = createAction<FetchSuccessPayload>(FETCH_SUCCESS);
export const fetchFailed = createAction(FETCH_FAILED);

const handleInitialize: HistoryEventsReducer<InitializePayload> = (state, { payload }) => ({
  ...state,
  ...payload,
  offset: 0,
  isLoading: true,
  events: [],
});

const handleLoadMoreStart: HistoryEventsReducer<LoadMorePayload> = (state, { payload }) => ({
  ...state,
  ...payload,
  isLoading: true,
});

const handleFetchSuccess: HistoryEventsReducer<FetchSuccessPayload> = (state, { payload }) => ({
  ...state,
  ...payload,
  isLoading: false,
});

const handleFetchFailed: HistoryEventsReducer = state => ({
  ...state,
  isLoading: false,
});

export default handleActions<HistoryEventsState, any>(
  {
    [INITIALIZE]: handleInitialize,
    [LOAD_MORE]: handleLoadMoreStart,
    [FETCH_SUCCESS]: handleFetchSuccess,
    [FETCH_FAILED]: handleFetchFailed,
  },
  initialState,
);

export const getHistoryEventsState: SelectorState<HistoryEventsState> = state => state.historyEvents;
